module.exports = __webpack_public_path__ + "media/images/icons/arrow_forward-30a4b66c68af374b94f725c7912b18d4.svg";